import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import _ from "lodash";

import { findUsers } from "./users";

// Fetch username data for a user id
export const fetchAdminNoteUser = async (userId, dictionaryUnknownUser) => {
	return findUsers({
		pageLimit: 100,
		pageOffset: 0,
		searchTerms: [
			{ key: "personId", val: userId },
		],
		includeInactive: true,
	}).then(response => {
		const person = response.find(foundPerson => foundPerson.personId === userId);

		return {
			name: isNonEmptyString(person?.fullName)
				? person.fullName
				: dictionaryUnknownUser || "Unknown User",
			nameId: userId,
		};
	}).catch(error => console.error("Error finding user", error));
};

const mapItemToFullName = userNames => item => ({
	...item,
	note: {
		...item.note,
		createdByFullName: userNames.find(userName => userName.nameId === item.note.createdBy)?.name,
		updatedByFullName: item.note.updatedBy
			? userNames.find(userName => userName.nameId === item.note.updatedBy)?.name
			: undefined,
	},
});

const normalizeAdminNoteMessage = item => {
	try {
		// try to decode to determine that the string is already decoded
		item.note.message = decodeURI(item.note.message);
	} catch {
		// do nothing
	} finally {
		// encode the string, since the component itself decodes the string
		item.note.message = encodeURI(item.note.message);
	}
};

export const mapAdminNotesResponse = async ({
	response,
	userNames,
	setUserNames,
	dictionaryUnknownUser,
}) => {
	if (!response.content) {
		return { data: [], totalItems: 0 };
	}

	response.content.forEach(normalizeAdminNoteMessage);

	// Replace note.createdBy with real usernames from findUser service call
	const knownUserIds = userNames.map(userName => userName.nameId);
	const userIds = _.uniq([
		...response.content.map(item => item.note.createdBy),
		...response.content.map(item => item.note.updatedBy),
	]).filter(Boolean);
	const unknownUserIds = userIds.filter(userId => !knownUserIds.includes(userId));

	let processedContent;

	if (unknownUserIds.length === 0) {
		processedContent = response.content.map(mapItemToFullName(userNames));
	} else {
		const newUserNames = await Promise.all(
			unknownUserIds.map(id => fetchAdminNoteUser(id, dictionaryUnknownUser))
		);
		const allUserNames = [ ...userNames, ...newUserNames ];
		setUserNames(allUserNames);
		processedContent = response.content.map(mapItemToFullName(allUserNames));
	}

	return {
		data: processedContent,
		totalItems: response.totalElements ?? processedContent.length,
	};
};
